import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="text-center">
        <p className="font-heading text-7xl font-extrabold text-primary">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold">Page not found</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          We can't find that page in your family hub.
        </p>
        <Link to="/">
          <Button className="mt-6">Go home</Button>
        </Link>
      </div>
    </div>
  );
}
